import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PaymentResult from "@/pages/PaymentResult";
import CaregiverBot from "@/pages/CaregiverBot";
import DocumentView from "@/pages/DocumentView";
import SeriesManage from "@/pages/SeriesManage";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Caregivers from "@/pages/admin/Caregivers";
import AdminBookings from "@/pages/admin/AdminBookings";
import Routing from "@/pages/admin/Routing";
import { Payouts, Payroll, WhatsAppLog, Waitlist } from "@/pages/admin/Money";
import EmailLog from "@/pages/admin/EmailLog";
import BrandKit from "@/pages/admin/BrandKit";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/caregiver" element={<CaregiverBot />} />
      <Route path="/dashboard" element={<ProtectedRoute role="diaspora"><Dashboard /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentResult cancelled /></ProtectedRoute>} />
      <Route path="/documents/:docId" element={<ProtectedRoute><DocumentView /></ProtectedRoute>} />
      <Route path="/series/manage/:token" element={<SeriesManage />} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="caregivers" element={<Caregivers />} />
        <Route path="bookings" element={<AdminBookings />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="whatsapp" element={<WhatsAppLog />} />
        <Route path="emails" element={<EmailLog />} />
        <Route path="brand" element={<BrandKit />} />
        <Route path="waitlist" element={<Waitlist />} />
        <Route path="routing" element={<Routing />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
